import { setData } from './account';

const roundsCompletedStorageKey = 'flagle-rounds-completed';
export const archiveRoundsCompletedStorageKey =
  'archive-flagle-rounds-completed';

export function loadArchiveCompleted(): string[] {
  const storedCompleted = localStorage.getItem(
    archiveRoundsCompletedStorageKey,
  );
  return storedCompleted != null ? JSON.parse(storedCompleted) : [];
}

export function loadCompleted(): Record<string, string[]> {
  const storedCompleted = localStorage.getItem(roundsCompletedStorageKey);
  return storedCompleted != null ? JSON.parse(storedCompleted) : {};
}

export function saveCompleted(
  dayString: string,
  completedRound: string,
  isArchive: boolean,
): void {
  if (isArchive) {
    const roundsCompleted = loadArchiveCompleted();
    if (roundsCompleted.includes(completedRound)) return;
    roundsCompleted.push(completedRound);
    localStorage.setItem(
      archiveRoundsCompletedStorageKey,
      JSON.stringify(roundsCompleted),
    );
    return;
  }

  const allCompleted = loadCompleted();
  const roundsCompleted = loadCompleted()[dayString] ?? [];
  if (roundsCompleted.includes(completedRound)) return;
  roundsCompleted.push(completedRound);

  const flagleRoundsCompleted = {
    ...allCompleted,
    [dayString]: roundsCompleted,
  };
  localStorage.setItem(
    roundsCompletedStorageKey,
    JSON.stringify(flagleRoundsCompleted),
  );

  setData('flagle-rounds-completed', flagleRoundsCompleted);
}
